import { ItemListOtherRowData } from "@/components/item-list/types/item-list-row-types";
import styled from "@emotion/styled";

export const ItemListOtherRow = ({ data }: { data: ItemListOtherRowData }) => {
  return <Wrapper>{data.payload.children}</Wrapper>;
};

const Wrapper = styled.div`
  min-height: 60px;
`;
